import _ from 'underscore';
import { NodeUpdatedHandler } from './event-handlers/event-handler';

export const isNodeEmpty = node =>
  node.children == null || node.children.length === 0;

export const findNodeIndexAtLevel = (nodes, node) =>
  (nodes ? _.findIndex(nodes, n => n.id === node.id) : -1);

export const FindMatchingNode = (nodes, node) => {
  const index = findNodeIndexAtLevel(nodes, node);
  let matchingNode = null;
  if (index === -1) {
    _.each(nodes, (n) => {
      const match = FindMatchingNode(n.children, node);
      if (match) {
        matchingNode = match;
      }
    });
  } else {
    matchingNode = nodes[index];
  }
  return matchingNode;
};

export const MergeSingleNode = (originalNode, node) => {
  if (isNodeEmpty(originalNode)) {
    return _.extend(originalNode, { children: node.children });
  } else if (isNodeEmpty(node)) {
    return originalNode;
  }
  const updatedNode = originalNode;
  _.each(node.children, (childNode) => {
    const index = findNodeIndexAtLevel(updatedNode.children, childNode);
    if (index !== -1) {
      updatedNode.children[index] = MergeSingleNode(updatedNode.children[index], childNode);
    } else {
      updatedNode.children.push(childNode);
    }
  });
  return updatedNode;
};

export const MergeNodesIntoTree = (originalNodes, nodes) => {
  let mergedNodes = originalNodes;
  _.each(nodes, (node) => {
    const matchingNode = FindMatchingNode(originalNodes, node);
    if (matchingNode) {
      const updatedNode = MergeSingleNode(matchingNode, node);
      mergedNodes = NodeUpdatedHandler(mergedNodes, updatedNode);
    } else {
      mergedNodes.push(node);
    }
  });
  return mergedNodes;
};
